import { TAccreditationBank } from '../../../types/accreditationBanks';
import { useApplicationContext } from '../../../utils/applicationContext';

type TBuildersToBanksMap = Partial<Record<string, TAccreditationBank[]>>;

const BUILDERS_TO_BANKS_MAP_CONFIG_KEY = 'countryside.buildersAccreditationBanks';

export const useBuilderToBanksMap = () => {
  const { config } = useApplicationContext();

  return config.get<TBuildersToBanksMap>(BUILDERS_TO_BANKS_MAP_CONFIG_KEY) || {};
};
